module.exports = __webpack_public_path__ + "img/logo-google.e99543bb.svg";